module.exports = __webpack_public_path__ + "static/card-3-9482cd9deacdad85c43b50166a48721d.png";